import { EmblaCarouselType } from 'embla-carousel';
import { Ref } from 'react';

import { LightboxImage as LightboxImageType } from '../../types';
import { LightboxImage } from '../LightboxImage/LightboxImage';

import { styles } from './ImagesCarousel.styles';

export interface ImagesCarouselProps {
  images: LightboxImageType[];
  emblaRef: Ref<HTMLDivElement>;
  emblaApi?: EmblaCarouselType;
  className?: string;
  selectedIndex: number;
  onOpenReview?: (reviewId: string) => void;
}

export function ImagesCarousel({
  images,
  emblaRef,
  emblaApi,
  className,
  selectedIndex,
  onOpenReview
}: ImagesCarouselProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      <div
        className={slots.viewport()}
        ref={emblaRef}
      >
        <div className={slots.carousel()}>
          {images.map((image, index) => (
            <div
              key={image.id}
              className={slots.slideContainer()}
            >
              <div className={slots.slide()}>
                <LightboxImage
                  image={image}
                  emblaApi={emblaApi}
                  active={index === selectedIndex}
                  onOpenReview={onOpenReview}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
